import axiosConfig from "./axiosConfig";

export interface MultiCurveCandidate {
  label: string;
  config: Record<string, unknown>;
  source: "sheet" | "column" | "measurement_point" | "row_meter";
  confidence: "high" | "medium" | "low";
  reasons: string[];
}

export interface DetectMultiCurveResponse {
  is_multi_curve: boolean;
  candidates: MultiCurveCandidate[];
  reason: string;
}

const postHhDataTempDetectMultiCurve = async (
  authToken: string,
  fileGuid: string
): Promise<DetectMultiCurveResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/temp/${fileGuid}/detect_multi_curve`,
    {},
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postHhDataTempDetectMultiCurve;
